.calendar [role='gridcell'] {
  justify-items: center;
}

.calendar [role='gridcell'] button {
  align-items: center;
  appearance: none;
  background: transparent;
  border: 0;
  box-sizing: border-box;
  color: inherit;
  display: flex;
  font: inherit;
  justify-content: center;
  padding-block: 4px;
  width: 100%;
}

.calendar [role='gridcell'] button[data-selected='true'] {
  background-color: var(--ds-background-selected, #e9f2fe);
  border-radius: var(--ds-radius-medium, 6px);
  color: var(--ds-text-selected, #1868db);
}

.calendar [role='gridcell'] button[data-selected='true']:hover {
  background-color: var(--ds-background-selected-hovered, #cfe1fd);
  color: var(--ds-text-selected, #1868db);
}

.calendar [role='gridcell'] button:hover {
  border-radius: var(--ds-radius-medium, 6px);
}

.calendar [role='gridcell'] button[data-sibling='true'] {
  color: var(--ds-text-subtlest, #6b6e76);
}

.calendar [role='gridcell'] button[data-sibling='true']:hover {
  color: var(--ds-text-subtlest, #6b6e76);
}

.calendar [role='gridcell'] button[data-today='true'] {
  color: var(--ds-text-selected, #1868db);
}

.calendar [role='gridcell'] button[data-today='true']::after {
  inset-inline-end: auto;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  width: 28px;
}
